import { __decorate, __extends } from "tslib";
import { CustomElement, element, props } from '@wk/custom-element';
import isServer from 'detect-node';
import { MAX_PHONE_WIDTH } from '../constants';
var FullscreenComponent = (function (_super) {
    __extends(FullscreenComponent, _super);
    function FullscreenComponent() {
        var _this = _super.call(this) || this;
        _this.isFullscreen = false;
        _this.blockTabNavigationInFullScreen = false;
        _this.isBodyOverflowHidden = false;
        _this._maxMobileWidth = MAX_PHONE_WIDTH;
        _this.setMediaQuery = function () {
            if (_this.mobileMediaQuery) {
                _this.mobileMediaQuery.removeListener(_this._onMobileMediaQuery);
            }
            _this.mobileMediaQuery = _this.ownerDocument.defaultView.matchMedia("(max-width: " + _this.maxMobileWidth + "px)");
            _this.mobileMediaQuery.addListener(_this._onMobileMediaQuery);
        };
        _this._onMobileMediaQuery = function (event) {
            if (event.matches) {
                if (_this.isFullscreen) {
                    _this.hideBodyOverflow();
                }
            }
            else if (!_this.isBodyOverflowHidden) {
                _this.resetBodyOverflow();
            }
            _this.emit('onMobileMediaQuery', event.matches);
        };
        _this.onFocusChange = function (event) {
            if (!_this.isFullscreen) {
                return;
            }
            _this.emit('onFocusChange', event.target);
        };
        _this.onDocumentKeyDown = function (event) {
            if (event.key === 'Tab' &&
                _this.isFullscreen &&
                _this.blockTabNavigationInFullScreen) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        };
        _this.bodyOverflow = _this.ownerDocument.body.style.overflow;
        return _this;
    }
    Object.defineProperty(FullscreenComponent.prototype, "maxMobileWidth", {
        get: function () {
            return this._maxMobileWidth;
        },
        set: function (maxWidth) {
            if (this._maxMobileWidth !== maxWidth) {
                this._maxMobileWidth = maxWidth;
                this.emit('onMobileMediaQuery', this.ownerDocument.defaultView.innerWidth <= maxWidth);
            }
        },
        enumerable: false,
        configurable: true
    });
    FullscreenComponent.prototype.connectedCallback = function () {
        _super.prototype.connectedCallback.call(this);
        this.style.display = 'none';
        if (!isServer) {
            this.setMediaQuery();
            this.emit('onMobileMediaQuery', this.ownerDocument.defaultView.innerWidth <= this.maxMobileWidth);
            this.ownerDocument.addEventListener('focusin', this.onFocusChange);
            this.ownerDocument.addEventListener('keydown', this.onDocumentKeyDown, true);
        }
    };
    FullscreenComponent.prototype.disconnectedCallback = function () {
        _super.prototype.disconnectedCallback.call(this);
        if (!isServer) {
            this.mobileMediaQuery.removeListener(this._onMobileMediaQuery);
            this.ownerDocument.removeEventListener('focusin', this.onFocusChange);
            this.ownerDocument.removeEventListener('keydown', this.onDocumentKeyDown, true);
        }
        this.resetBodyOverflow();
    };
    FullscreenComponent.prototype.propsChangedCallback = function (propName, prev, next) {
        _super.prototype.propsChangedCallback.call(this, propName, prev, next);
        if (!isServer) {
            this.setMediaQuery();
        }
        if (this.isFullscreen || this.isBodyOverflowHidden) {
            this.hideBodyOverflow();
        }
        else {
            this.resetBodyOverflow();
        }
        if (propName === 'isFullscreen' && prev !== next) {
            this.emit('onMobileMediaQuery', this.isFullscreen);
        }
    };
    FullscreenComponent.prototype.hideBodyOverflow = function () {
        this.bodyOverflow = this.ownerDocument.body.style.overflow;
        var _a = this.ownerDocument.defaultView.getComputedStyle(this.ownerDocument.body), marginRight = _a.marginRight, marginLeft = _a.marginLeft;
        this.bodyMarginRight = marginRight;
        var marginLeftPx = parseInt(marginLeft, 10);
        this.bodyOffsetRight =
            this.ownerDocument.defaultView.innerWidth -
                this.ownerDocument.body.clientWidth -
                marginLeftPx;
        this.ownerDocument.body.style.overflow = 'hidden';
        this.ownerDocument.body.style.marginRight = this.bodyOffsetRight + "px";
    };
    FullscreenComponent.prototype.resetBodyOverflow = function () {
        this.ownerDocument.body.style.overflow = this.bodyOverflow;
        this.ownerDocument.body.style.marginRight = this.bodyMarginRight;
    };
    __decorate([
        props.boolean
    ], FullscreenComponent.prototype, "isFullscreen", void 0);
    __decorate([
        props.number
    ], FullscreenComponent.prototype, "maxMobileWidth", null);
    __decorate([
        props.boolean
    ], FullscreenComponent.prototype, "blockTabNavigationInFullScreen", void 0);
    __decorate([
        props.boolean
    ], FullscreenComponent.prototype, "isBodyOverflowHidden", void 0);
    FullscreenComponent = __decorate([
        element('wk-fullscreen')
    ], FullscreenComponent);
    return FullscreenComponent;
}(CustomElement));
export { FullscreenComponent };
